import { IContainer, injectContainer } from './container';

export interface ICache {
    add: (key: string | symbol, value: any) => void;
    get: (key: string | symbol) => any;
}

export interface ICacheController {
    getAssociatedCache: (associatedObject: any) => ICache | null;
    getGlobalCache: () => ICache;
}

const TYPES = {
    ICache: Symbol.for('ICache'),
    ICacheController: Symbol.for('ICacheController'),
};

export function injectCache(container: IContainer = injectContainer()): ICache {
    return container.get<ICache>(TYPES.ICache);
}

export function bindCache(val: ICache, container: IContainer = injectContainer()) {
    return container.bind<ICache>(TYPES.ICache, val);
}

export function injectCacheController(container: IContainer = injectContainer()): ICacheController {
    return container.get<ICacheController>(TYPES.ICacheController);
}

export function bindCacheController(
    val: ICacheController,
    container: IContainer = injectContainer(),
) {
    return container.bind<ICacheController>(TYPES.ICacheController, val);
}
